// extracted by mini-css-extract-plugin
module.exports = {"top":"_1bgmbASQooSf1H1Brqe5cL","rmBtn":"_33cto5Wm9rc-tmUCFkfZ-T","contentHolder":"EZxRRK3NsY16-MIvebsRF","content":"_1QttpmaNmNKoUDh1Uo6Cs"};